module.exports = __webpack_public_path__ + "static/media/8.369e49be.mp3";